import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/roomService",
  name: "roomService",
  redirect: "/roomService/Index",
  component: RouteView,
  meta: {
    title: "房务管理",
    showNavBar: false,
  },
  children: [
    {
      path: "/roomService/Index",
      name: "RoomServiceIndex",
      component: () => import("@/views/roomService/Index.vue"),
      meta: {
        title: "房务管理列表",
        showNavBar: true,
      },
    },
  ],
};
